export const createRuntimeOperationType = (operationType) => {
    return operationType;
};
export const isRuntimeOperationConfig = (value) => {
    return (typeof value === 'object' &&
        value !== null &&
        'kind' in value &&
        typeof value.kind === 'string' &&
        'value' in value &&
        !('typeName' in value));
};
export const isRecord = (value) => {
    return typeof value === 'object' && value !== null;
};
export const containsOperationRuntimeConfig = (value) => {
    if (Array.isArray(value)) {
        return value.some(containsOperationRuntimeConfig);
    }
    if (isRuntimeOperationConfig(value)) {
        return true;
    }
    if (typeof value === 'object' && value !== null) {
        return Object.entries(value).some(([key, value]) => {
            if (typeof value === 'object' &&
                value !== null &&
                'kind' in value &&
                key === 'parent') {
                return false;
            }
            return containsOperationRuntimeConfig(value);
        });
    }
    return false;
};
export const extractValueFromContext = (selector, context) => {
    if (selector.length === 0)
        return context;
    const [key, ...rest] = selector;
    if (Array.isArray(context)) {
        return extractValueFromContext(selector, context[0]);
    }
    if (typeof context === 'function') {
        return extractValueFromContext(selector, context());
    }
    if (typeof context === 'object' && context !== null) {
        return extractValueFromContext(rest, context[key]);
    }
    return undefined;
};
//# sourceMappingURL=common.js.map